import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { PERSISTED_SLICES } from '../persistence/persistence.registry';
import { ValueHelperEffects } from './effects/value-helper.effects';
import { valueHelperReducer } from './reducers/value-helper.reducer';
import { selectValueHelperModels } from './selectors/value-helper.selector';
import { VALUE_HELPER_FEATURE_KEY } from './value-helper-collection.state';

/**
 * Registers the value-help feature slice. `ValueHelperNgrxService.init()` loads the data from
 * the backend and dispatches `valueHelpersLoaded`; `ValueHelperEffects` then mirrors the slice
 * to the generic persistence layer, which caches it in the concurrency store under the default
 * `valueHelperSlice` key so value helpers are available offline. The backend stays the source
 * of truth (see the effect).
 */
@NgModule({
    imports: [
        StoreModule.forFeature(VALUE_HELPER_FEATURE_KEY, valueHelperReducer),
        EffectsModule.forFeature([ValueHelperEffects]),
    ],
    providers: [
        {
            provide: PERSISTED_SLICES,
            multi: true,
            useValue: {
                featureKey: VALUE_HELPER_FEATURE_KEY,
                persistSelector: selectValueHelperModels,
            },
        },
    ],
})
export class ValueHelperStoreModule {}
